/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

var injectKey = Symbol("dropdownProvider");

export { injectKey };
//# sourceMappingURL=const.mjs.map
